export { default as parseHostname } from './parseHostname';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/parse-hostname/es/index.js
// module id = null
// module chunks = 